import * as joint from 'jointjs';

// 一个菜单项
export class ContextEnumItem {
  name: string;
  actionName: string; // 菜单对应的动作名称，发起回调事情
  isEnabled: boolean; // 是否可用，不可用则为灰色
  constructor(name: string, actionName: string, isEnabled: boolean) {
    this.name = name;
    this.actionName = actionName;
    this.isEnabled = isEnabled;
  }
}

// 一组菜单项，组间进行分隔
export class ContextEnumItemGroup {
  items: Array<ContextEnumItem>;

  constructor() {
    this.items = new Array<ContextEnumItem>();
  }

  addItem(enumItem: ContextEnumItem) {
    this.items.push(enumItem);
  }
}

export const ContextMenu = joint.shapes.basic.Generic.define(
  'mst.ContextMenu',
  {
    attrs: {
      rect: { width: 120, 'stroke-width': 0, fill: '#545c64' },
      '.uml-menu-container': { strokeWidth: 1, stroke: '#000000', fill: '#000000' },
      '.uml-menu-item-rect': { height: 25, style: 'cursor:default', event: 'cmenu:action' },
      '.uml-menu-item-text': { fontSize: 12, fill: 'white', style: 'cursor:default', event: 'cmenu:action' }
    },
    content: [],
    /** 是否需要上下移动相关的菜单组（移到顶部、上移、下移、移到尾部） */
    hasMoveGroup: false,
    /** 移动菜单组中，当前项的索引，1代表第一项 */
    rowIndex: 1,
    /** 移动菜单组中，当前项是否是最后一项 */
    isLastRow: false,
    /** 是否需要编辑相关的菜单组（剪切、复制、粘贴、删除） */
    hasEditGroup: false
  },
  {
    markup: '',

    initialize() {
      this.on(
        'change:content change:hasMoveGroup change:hasEditGroup',
        () => {
          this.updateRectangles();
        },
        this
      );

      this.updateRectangles();

      joint.shapes.basic.Generic.prototype.initialize.apply(this, []);
    },

    updateRectangles() {
      const t_item_rect = '<rect class="uml-menu-item-rect" transform="translate(0, {offsetY})" action="{action}"/>';
      const t_item_text = '<text class="uml-menu-item-text" transform="translate(10, {offsetY})" action="{action}">{text}</text>';
      const rects: Array<string> = new Array<string>();
      const texts: Array<string> = new Array<string>();

      const lineHeight = 25;

      let offsetY = 0;
      let isFirstGroup = true;
      const groups = this.get('content') as Array<ContextEnumItemGroup>;
      if (this.get('hasEditGroup')) {
        const editGroup = new ContextEnumItemGroup();
        editGroup.addItem(new ContextEnumItem('剪切', 'shape:cut', false));
        editGroup.addItem(new ContextEnumItem('复制', 'shape:copy', false));
        editGroup.addItem(new ContextEnumItem('粘贴', 'shape:paste', false));
        editGroup.addItem(new ContextEnumItem('删除', 'shape:deleteChild', false));
        groups.push(editGroup);
      }
      if (this.get('hasMoveGroup')) {
        const index = parseInt(this.get('rowIndex'));
        const isLast = this.get('isLastRow');
        const moveGroup = new ContextEnumItemGroup();
        if (index !== 1) {
          moveGroup.addItem(new ContextEnumItem('移到顶部', 'row:moveTop', false));
          moveGroup.addItem(new ContextEnumItem('上移', 'row:moveUp', false));
        }
        if (!isLast) {
          moveGroup.addItem(new ContextEnumItem('下移', 'row:moveNext', false));
          moveGroup.addItem(new ContextEnumItem('移到尾部', 'row:moveBottom', false));
        }
        groups.push(moveGroup);
      }
      if (groups && groups.length > 0) {
        groups.forEach(group => {
          if (isFirstGroup) {
            isFirstGroup = false;
          } else {
            offsetY += 1; // 分隔线
          }
          group.items.forEach(item => {
            rects.push(t_item_rect.replace('{offsetY}', offsetY.toString()).replace('{action}', item.actionName));
            texts.push(
              t_item_text
                .replace('{offsetY}', (offsetY + 18).toString())
                .replace('{action}', item.actionName)
                .replace('{text}', item.name)
            );
            offsetY += lineHeight;
          });
        });
      }

      const markup: Array<string> = new Array<string>();
      markup.push('<g class="rotatable">');
      markup.push('<g>');
      markup.push(`<rect class="uml-menu-container" height="${offsetY}"/>`);
      markup.push(rects.join(''));
      markup.push('</g>');
      markup.push(texts.join(''));
      markup.push('</g>');
      this.set('markup', markup.join(''));
    }
  }
);
